import { useEffect } from 'react';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { useEnrollments } from '@/hooks/queries';
import { useIsDesktop } from '@/hooks/useIsDesktop';
import { DesktopCourseDetail } from './desktop/DesktopCourseDetail';
import { MobileCourseDetail } from './mobile/MobileCourseDetail';

export function LearnerCourseDetail() {
  const isDesktop = useIsDesktop();
  const { id = '' } = useParams();
  const { pathname } = useLocation();
  const navigate = useNavigate();
  const { data: enrollments } = useEnrollments();

  // One canonical home per course: the catalog is for discovering/enrolling, so
  // an already-enrolled course belongs under /learn/learning/:id (keeps the
  // "Learning" tab active). If it's opened on the catalog path, send it there.
  const onCatalogPath = pathname.startsWith('/learn/catalog/');
  const enrolled = !!enrollments?.some((e) => e.courseId === id);
  useEffect(() => {
    if (enrolled && onCatalogPath) navigate(`/learn/learning/${id}`, { replace: true });
  }, [enrolled, onCatalogPath, id, navigate]);

  return isDesktop ? <DesktopCourseDetail /> : <MobileCourseDetail />;
}
